import { PerfilUsuarioModel } from 'api/master/models/perfil/perfil-usuario-model';
import React from 'react';
import { UsuarioMaster } from './usuario-master';
import { useObterToken } from 'services/store/obter-token';

interface UsuarioContextValue {
  usuario?: UsuarioMaster;
  logar: (token?: string | null, perfil?: PerfilUsuarioModel | null) => boolean;
  deslogarUsuario: () => void;
}

const UsuarioContext = React.createContext<UsuarioContextValue>({
  usuario: undefined,
  logar: (token?: string | null | undefined, perfil?: PerfilUsuarioModel | null) => false,
  deslogarUsuario: () => { },
});

export interface UsuarioProviderProps {
  children: React.ReactNode;
}

export const useUsuarioLogado = () => {
  return React.useContext(UsuarioContext);
};

export const UsuarioProvider = ({ children }: UsuarioProviderProps) => {

  var r = UsuarioMaster.fromLocalStorageToken();

  const [usuario, setarUsuario] = React.useState(r);
  const { setToken } = useObterToken()

  const deslogarUsuario = React.useCallback(() => {
    setToken(undefined);
  }, [setToken]);

  const logar = React.useCallback((token?: string | null, perfil?: PerfilUsuarioModel | null) => {
    const resultado = UsuarioMaster.persistFromToken(token, perfil);
    setarUsuario(resultado);
    return resultado.invalido() === false;
  }, []);

  return (
    <UsuarioContext.Provider
      value={{
        usuario,
        deslogarUsuario,
        logar,
      }}
    >
      {children}
    </UsuarioContext.Provider>
  );
};
